function compare(a, b) {
  if (a === b) return 0;
  return a < b ? -1 : 1;
}

export default function orderBy(field, convert = x => x) {
  let asc = (a, b) => compare(convert(a[field]), convert(b[field]));
  let desc = (a, b) => compare(convert(b[field]), convert(a[field]));
  asc.asc = asc;
  asc.desc = desc;
  return asc;
}

export const byCreatedAt = orderBy('created_at', x => new Date(x).getTime());
export const byUpdatedAt = orderBy('updated_at', x => new Date(x).getTime());
